import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LinkHub from "@/components/LinkHub";
import LandingPage from "@/components/LandingPage";
import GiveawayPage from "@/components/GiveawayPage";
import { SHOW_COPYTRADE } from "@/lib/links";

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<LinkHub />} />
        <Route
          path="/copytrade"
          element={SHOW_COPYTRADE ? <LandingPage /> : <Navigate to="/" replace />}
        />
        <Route path="/giveaway" element={<GiveawayPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
